import React, { useEffect, useState } from 'react';
import { useThemeMode } from '../../../context/contextTheme';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './style.css';

const SavesetScore = ({ setScore }) => {
  const { theme } = useThemeMode();
  const [displayScore, setDisplayScore] = useState(0);
  const [pathColor, setPathColor] = useState('#6d2d9d');
  const [cardScoreLabel, setCardScoreLabel] = useState('Poor');
  const hasScore = setScore !== null
    && setScore !== undefined
    && setScore !== ''
    && Number.isFinite(Number(setScore));
    
  // Convert and sanitize score value
  useEffect(() => {
    let score = parseFloat(setScore);

    score = hasScore ? Math.min(10, Math.max(0, score)) : 0;
    
    setDisplayScore(score);
    setCardScoreLabel(getCardScoreLabel(score));
    setPathColor(getPathColor(score));
  }, [hasScore, setScore]);

  const getCardScoreLabel = (score) => {
    if (score >= 8) return 'Excellent';
    if (score >= 6) return 'Good';
    if (score >= 4) return 'Average';
    return 'Poor';
  };

  const getPathColor = (score) => {
    if (score >= 8) return '#92d14f';
    if (score >= 6) return '#ffc000';
    if (score >= 4) return '#fc0000';
    return '#6d2d9d';
  };

  return (
    <div className="p-2 pb-0 mb-3">
      <div 
        className="card rounded-4 shadow-sm" 
        style={{ 
          minWidth: 300, width: 360,
          backgroundColor: theme.background, 
          border: `1px solid ${theme.border}`
        }}>
        <div className="card-body d-flex justify-content-between align-items-center" style={{ height: 240 }}>
          
          {/* Title Section */}
          <div className="ps-2" style={{ fontWeight: 600, lineHeight: 1.3 }}>
            <div style={{ fontSize: 28, color: theme.textMuted }}>Security</div>
            <div style={{ fontSize: 40, color: theme.textColor }}>Audit</div>
            <div style={{ fontSize: 28, color: theme.textMuted }}>Score</div>
          </div>

          {/* Score Section */}
          <div className="d-flex flex-column align-items-center pe-2">
            <div style={{ width: 130 }}>
              <CircularProgressbar
                value={displayScore * 10}
                text={`${hasScore ? displayScore : '-'}`}
                strokeWidth={8}
                styles={buildStyles({
                  textSize: '40px',
                  textColor: theme.textColor,
                  pathColor: pathColor,
                  trailColor: '#ececec',
                  strokeLinecap: 'round',
                })}
              />
            </div>
            <div className="text-center mt-2">
              <div className="small" style={{ color: theme.textMuted }}>R. Factor:</div>
              <div className="fw-bold" style={{ fontSize: 18, color: theme.textColor }}>
                {hasScore ? cardScoreLabel : 'N/A'}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SavesetScore;
